export default !!window.navigator.platform &&
  /iPad|iPhone|iPod/.test(navigator.platform);
